import styled from "styled-components";

import { StyledBaseHeader } from "@/components/layouts/styled";
import { breakpoints } from "@/styles/breakpoints";

export const StyledNoAuthHeader = styled(StyledBaseHeader)`
    height: 5.2rem;
    padding: 1.8rem 50px 0 50px;
    @media ${breakpoints.sm} {
        padding: 1.8rem 15px 0 15px;
    }
    @media ${breakpoints.xs} {
        padding: 0 10px;
    }
    .logo {
        z-index: 1;
        .MuiButton-label {
            width: auto;
        }
        .logoDisplayer {
            @media ${breakpoints.xs} {
                width: 109px;
                height: 24px;
            }
            svg {
                @media ${breakpoints.xs} {
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }
    .header-components-action {
        display: inline-flex;
        justify-content: flex-end;
        width: 100%;
        flex-direction: row;
    }
`;
